import { formatUtcIsoDateTime, formatIsoDate } from 'helpers/DateHelper';
import { createBookingItem } from 'logic/bookingLogic';
import cancellationReasons from 'enums/cancellationReasons';

export const createUpdateBookingRequest = (formValues, storageSite, appContext) => ({
    startDate: formatIsoDate(formValues.startDate, appContext),
    endDate: formatIsoDate(formValues.endDate, appContext),
    actualEndDate: formatIsoDate(formValues.actualEndDate, appContext),
    confirmationDeadline: formatUtcIsoDateTime(formValues.confirmationDeadline),
    initialPaymentDeadline: formatUtcIsoDateTime(formValues.initialPaymentDeadline),
    subscriptionReactivationDeadline: formatUtcIsoDateTime(formValues.subscriptionReactivationDeadline),
    flagged: formValues.flagged,
    cancellationReason: formValues.cancellationReason,
    cancellationReasonText: formValues.cancellationReason === cancellationReasons.other.key
        ? formValues.cancellationReasonText
        : undefined,
    subscriptionEndReason: formValues.subscriptionEndReason,
    minimumBookingLength: formValues.minimumBookingLength,
    bookingItems: ([formValues.storageBookingItem].concat(formValues.bookingItems)).map(formBookingItem => createBookingItem(formBookingItem, storageSite, appContext)),
    storageGroupId: formValues.storageGroupId,
    storageId: formValues.storageId,
    tenantActorId: formValues.tenantActorId,
    bookingStatus: formValues.bookingStatus,
    tenantReferenceText: formValues.tenantReferenceText
        ? formValues.tenantReferenceText
        : undefined,
    createPostInvoiceForExtendedTimePeriod: formValues.createPostInvoiceForExtendedTimePeriod
});
